export default __webpack_public_path__ + "4c2d91ee01ab00ce91de7f1ddc848fb0.png";